// extracted by mini-css-extract-plugin
export default {"background":"future_utsMGSXExLkm","yellowBackground":"future__kPTof2Wc5XD","greenBackground":"future_PWeuEw9_ESsR"};